__turbopack_context__.v({
  "dashed": "SideBar-module__OeeAXq__dashed",
});
